import React from 'react';
import { useAuth } from './common/Auth';
import SystemList from './SystemList';
import { firestore } from './common/firebase';
import { doc, deleteDoc, updateDoc } from 'firebase/firestore';

const Home = ({ onSystemSelected }) => {
	const currentUser = useAuth();

	const doDeleteSystem = (system) => {
		deleteDoc(doc(firestore, 'systems', system.uid));
	};

	const doForgetSystem = (system) => {
		if (system.guests != undefined && system.guests.length > 0) {
			const index = system.guests.indexOf(currentUser.uid);
			if (index >= 0 && index < system.guests.length) {
				system.guests.splice(index, 1);
			}
		}
		delete system.permissions[currentUser.uid];
		updateDoc(doc(firestore, 'systems', system.uid), { guests: system.guests, permissions: system.permissions });
	};

	return (
		<div className="min-h-full">
			<SystemList
				user={currentUser}
				onSystemSelected={onSystemSelected}
				deleteSystem={doDeleteSystem}
				forgetSystem={doForgetSystem}
			/>
		</div>
	);
};

export default Home;
